import React from "react";
import i18next from "i18next";
import Cookies from "js-cookie";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "../../../../utils/consts";

import { StyledLanguageSelect } from "./styledLanguageSelect";

const LanguageSelect = () => {

  const handleChangeLang = (e) => {
    i18next.changeLanguage(e.target.value);
  };

  return (
    <StyledLanguageSelect className="lang-select-wrapper">
      {/* No need to change on Autocomplete component (language select) */}
      <Select
        labelId="language-label"
        id="language"
        className="lang-select"
        name="lang"
        value={Cookies.get("i18next") ?? DEFAULT_LANGUAGE}
        onChange={handleChangeLang}
      >
        {Object.entries(SUPPORTED_LANGUAGES).map(([key, value]) => {
          return (
            <MenuItem key={key} value={key}>
              <div className="lang-select__item">
                <span className="lang-select__pref">{key}</span>
                <span className="lang-select__text">{value.description}</span>
              </div>
            </MenuItem>
          );
        })}
      </Select>
    </StyledLanguageSelect>
  );
};

export default LanguageSelect;